import { render, staticRenderFns } from "./FireCauseLocalOrigin.vue?vue&type=template&id=339b2ccb&scoped=true"
import script from "./FireCauseLocalOrigin.vue?vue&type=script&lang=ts"
export * from "./FireCauseLocalOrigin.vue?vue&type=script&lang=ts"
import style0 from "./FireCauseLocalOrigin.vue?vue&type=style&index=0&id=339b2ccb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339b2ccb",
  null
  
)

export default component.exports